import React, { useEffect, useState } from 'react';
import { Button, Col, Label, Row } from 'reactstrap';
import '../../../assets/style/LatestUpdates.css';
import MTextField from '../../../components/MTextField';
import UpdatesPreview from './UpdatesPreview';
import { useAppDispatch, useAppSelector } from '../../../store/redux-hooks';
import {
  getLatestUpdatesAllList,
  latestUpdatesSelector,
} from '../../../features/latestUpdatesSlice';
import KPagination from '../../../components/KPagination';
import { API_STATUS, DEFAULT_PAGE_SIZE } from '../../../utils/Constant';
import CenterSpinner from '../../../components/CenterSpinner';
import { toast } from 'react-toastify';
import AlertPopUP from '../../modals/AlertPopUp';
import {
  alertPopupToggle,
  handleCancel,
  handleChange,
  handleUpload,
  onRemove,
} from './latestUpdatesHelper';

const LatestUpdatesPage: React.FunctionComponent = () => {
  const [update, setUpdate] = useState<string>();
  const updatesList = useAppSelector(latestUpdatesSelector).allList.updates;
  const pagination = useAppSelector(latestUpdatesSelector).allList.pagination;
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [showAlertPopUp, setShowAlertPopUp] = useState<boolean>(false);
  const [removeUpdateId, setRemoveUpdateId] = useState<any>('');

  const dispatch = useAppDispatch();
  const apiStatus: string = useAppSelector(
    latestUpdatesSelector
  ).allListAPIStatus;

  useEffect(() => {
    dispatch(
      getLatestUpdatesAllList({
        pageNumber: currentPage,
        pagePerCount: pageSize,
      })
    );
  }, [currentPage, pageSize]);

  useEffect(() => {
    if (apiStatus === API_STATUS.FAILED || apiStatus === API_STATUS.SUCCEEDED) {
      setShowLoader(false);
    } else if (apiStatus === API_STATUS.LOADING) {
      setShowLoader(true);
    }
  }, [apiStatus]);

  return (
    <div className="ml-4">
      <Label className="text-heading">Latest Updates</Label>
      <div className="task-item-parent-view bg-white">
        <div className="border rounded p-3 ps-4 me-3">
          <Label className="title">Latest Update</Label>
          <div className="input-update mb-1">
            <MTextField
              label=""
              placeholder="Enter latest update"
              value={update}
              onChange={(e) => {
                const value = e.target.value?.trimStart();
                handleChange(value, setUpdate);
              }}
            />
          </div>
          <Label className="subtitle">(Max 150 characters)</Label>
          <Row className="ps-0">
            <Col
              xs={12}
              md={4}
              className="d-flex align-items-center pt-2 pb-3 filter-button-parent"
            >
              <Button
                variant="primary"
                className="cl-btn-primary"
                onClick={() => {
                  handleUpload(
                    currentPage,
                    pageSize,
                    update,
                    setUpdate,
                    setShowLoader,
                    dispatch,
                    toast
                  );
                }}
              >
                Upload
              </Button>
              <Button
                variant="outline-primary"
                className="mx-2 cl-btn-outline-primary"
                onClick={() => {
                  handleCancel(setUpdate);
                }}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </div>
        <div className="latest-updates">
          <UpdatesPreview
            updates={updatesList}
            handleRemove={(id: number | string) => {
              onRemove(id, setShowAlertPopUp, setRemoveUpdateId);
            }}
          />
        </div>
        {updatesList.length ? (
          <KPagination
            totalPages={pagination?.totalPages}
            currentPage={pagination?.currentPage}
            pageSize={pageSize}
            onPageChange={setCurrentPage}
            onSizeChange={setPageSize}
            fromItem={pagination?.fromItem}
            toItem={pagination?.toItem}
            totalItems={pagination?.totalItems}
          />
        ) : (
          ''
        )}
      </div>
      <CenterSpinner showLoader={showLoader} className="spinner-60" />
      {showAlertPopUp && (
        <AlertPopUP
          isOpen={showAlertPopUp}
          toggle={(action: string) => {
            alertPopupToggle(
              action,
              currentPage,
              pageSize,
              removeUpdateId,
              setShowLoader,
              dispatch,
              toast,
              setShowAlertPopUp,
              setRemoveUpdateId
            );
          }}
        />
      )}
    </div>
  );
};

export default LatestUpdatesPage;
